export function BackButtonIcon() {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g data-figma-bg-blur-radius="87.5">
        <rect
          x="0.875"
          y="0.875"
          width="40.25"
          height="40.25"
          rx="20.125"
          stroke="url(#paint0_linear_20958_49547)"
          strokeWidth="1.75"
        />
        <path
          d="M23.0009 26.88L18.1109 21.99C17.5334 21.4125 17.5334 20.4675 18.1109 19.89L23.0009 15"
          stroke="#333333"
          strokeWidth="1.6"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_20958_49547"
          x1="22.4882"
          y1="-7.88143e-07"
          x2="34.3401"
          y2="38.3359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.3" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
